module.exports = __webpack_public_path__ + "img/map.78e887d9.svg";